// Bileli · shared/i18n — the Bileli-app INTERFACE LANGUAGE (ru ⇄ ky), persisted per browser. This is the
// Bileli half only: Telegram chrome keeps its own language engine (Settings → Language). Server-side
// persistence is a possible future ask — /me has no writable locale today.

import { createStore } from '../lib/zustandTeact';

export type BileliLang = 'ru' | 'ky';

const LANG_KEY = 'bileli:lang';

function readLang(): BileliLang {
  try {
    return localStorage.getItem(LANG_KEY) === 'ky' ? 'ky' : 'ru';
  } catch {
    return 'ru';
  }
}

export const bileliLangStore = createStore<{ lang: BileliLang }>(() => ({ lang: readLang() }));

export function setBileliLang(lang: BileliLang): void {
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {
    // storage unavailable — the choice just won't survive a reload
  }
  bileliLangStore.setState({ lang }, true);
}
